import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { Subject } from '../../models/subjects/subject';
import { Response } from '@angular/http';
import { HttpClientService } from '../http-client/http-client.service';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import { AddSubjectDto } from '../../models/subjects/dto/addSubjectDto';
import { SubjectSchedule } from '../../models/subjects/dto/SubjectSchedule';
import { Noticia } from '../../models/noticias/noticia';

@Injectable()
export class NoticiasService {

    public noticias: Noticia[];
    public noticiasObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.noticias = [];
        this.noticiasObject = {};
    }

    public getAll(): Observable<Noticia[]> {
        // if (!!this.noticias && this.noticias.length > 0) {
        //     return Observable.create((observer: Subscriber<Noticia[]>) => {
        //         observer.next(this.noticias);
        //         observer.complete();
        //     });
        // }
        const url = 'noticias/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.noticias = r.Result;
                this.noticiasObject = this.noticias.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('StudentService > getAll > response', r);
            }
            return this.noticias;
        }).catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public add(addSubjectDto: any) {
        const url = 'noticias/add';
        return this.http.post(url, addSubjectDto).map(response => response.json())
            .catch(this.handleError);
    }

    public edit(addSubjectDto: any) {
        const url = 'noticias/add';
        return this.http.post(url, addSubjectDto).map(response => response.json())
            .catch(this.handleError);
    }
    public checkBeforeSave(id: any, noticiaId: any) {
        const url = 'noticias/checkBeforeSave/' + id+ "/"+noticiaId;
        return this.http.get(url).map((response: any) => {
            let r = response.json();
            if (r.ResultCode === 1 && r.Result != null) {
                return r.Result;   
            } else {
                return false;
            }
        }).catch(this.handleError);
    }

    public delete(addSubjectDto: any) {
        const url = 'noticias/delete';
        return this.http.post(url, addSubjectDto).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/noticias/noticias.service.ts